import { badgeTemplateClassifierEntityName, } from '../../../../backend/config/classifiers/badge-template-classifier/types';
import { useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
/**
 * Wrapper around useStorageList to be used more like Server State Manager
 */
export function useStorageListBadgeTemplates() {
    return useStorageList(badgeTemplateClassifierEntityName, {
        filter: [{ column: 'status', op: '=', value: 'active' }],
    }, undefined, undefined, {
        dedupingInterval: 10000, // avoid re-fetching for period
    });
}
